<div class="f-pig w-full flex justify-center items-center">
	<img class="w-2/3 h-2/3" *ngIf="mobileSlider.length === 0" src="assets/no-image.png" alt="spectacle hub">
</div>
<div *ngIf="mobileSlider.length > 0" class="f-pig w-full flex flex-col justify-center items-center">

	<div #zoomDiv
		 [ngClass]="'f-pig-main-image-container-small'"
		 class="f-pig-main-image-container relative flex flex-row justify-center items-center">
		<div (next)="nextImage(selectedIndex)"
			 (previous)="prevImage(selectedIndex)"
			 class="flex justify-end "
			 fbSwipe>
			 <div [id]="'id-pig-image-card'">
				<img *ngIf="!mobileSlider[selectedIndex].image.includes('youtu')"
				 [alt]="mobileSlider[selectedIndex].altText"
				 [src]="mobileSlider[selectedIndex].image"
				 onerror="this.src='assets/no-image.png'"
				 class="f-pig-main-image"
				 height="480"
				 width="auto" />
			 </div>

			<div [id]="'id-pig-image-card-video'" class="relative flex justify-center items-center">
				<ng-container *ngIf="mobileSlider[selectedIndex].image.includes('youtu')" >
					<img [alt]="mobileSlider[0].altText"
						 [src]="mobileSlider[0].image"
						 onerror="this.src='assets/no-image.png'"
						 (click)="openVideoDialog()"
						 class="f-pig-main-image"
						 height="480"
						 width="auto" />
					<img class="w-[100px] absolute"
						 (click)="openVideoDialog()"
						 src="assets/img/youtube_shorts_icon.svg" [alt]="mobileSlider[0].altText">
				</ng-container>

			</div>
		</div>
	</div>
	<div class="f-pig-gallery-container flex flex-col justify-center items-stretch">
		<div class=" flex flex-row justify-center items-center">
			<ng-container *ngFor="let entry of mobileSlider; let i = index" class="f-non-selectable f-no-focus">
				<div *ngIf="i === selectedIndex; then imageSelectedTemplate else imageUnselectedTemplate"></div>
				<ng-template #imageSelectedTemplate>
					<span (click)="switchImage(i)"
						  class="f-pig-image-control-selected">
						<div *ngIf="!entry.image.includes('youtu')" class="f-pig-circle-selected"></div>
						<div *ngIf="entry.image.includes('youtu')" class="f-pig-circle-selected flex justify-center items-center">
							<div class="video-thumbnail"></div>
						</div>
					</span>
				</ng-template>
				<ng-template #imageUnselectedTemplate>
					<span (click)="switchImage(i)"
						  class="f-pig-image-control-unselected">
						<div *ngIf="!entry.image.includes('youtu')" class="f-pig-circle-unselected"></div>
						<div *ngIf="entry.image.includes('youtu')" class="f-pig-circle-unselected flex justify-center items-center">
							<div class="video-thumbnail"></div>
						</div>
					</span>
				</ng-template>
			</ng-container>
		</div>
	</div>
</div>
